import { PRODUCTS as products } from 'common/constants'
import { productIdFromEdgeProduct } from 'common/api/v1/helpers'
import { EdgeProduct } from 'common/api/v1/types'

export const IS_PROD = process.env.NODE_ENV === 'production'
export const REACT_APP_EDGE_PRODUCT = productIdFromEdgeProduct(
  (process.env.REACT_APP_EDGE_PRODUCT as EdgeProduct) || EdgeProduct.edge,
)
export const IS_CONNECT_IT = REACT_APP_EDGE_PRODUCT === products.connectIt.id

export const MAPBOX_TOKEN = process.env.MAPBOX_TOKEN
export const MIXPANEL_TOKEN = (window as any).Cypress ? undefined : process.env.MIXPANEL_TOKEN
